export default "__VITE_ASSET__CWexoMN4__"